import { useT } from '@/lib/i18n';

/** Tiny FR | EN toggle. */
export function LangSwitcher({ variant = 'light' }: { variant?: 'light' | 'dark' }) {
  const { lang, setLang } = useT();
  const base =
    variant === 'dark'
      ? 'inline-flex items-center gap-1 border border-paper/30 rounded-full text-paper text-[12px] overflow-hidden'
      : 'inline-flex items-center gap-1 border-2 border-ink rounded-full bg-white text-ink text-[12px] overflow-hidden';
  const pill = 'px-2 py-[2px] font-hand cursor-pointer';
  return (
    // biome-ignore lint/a11y/useSemanticElements: <fieldset> imposes block layout that breaks the inline pill design — role="group" on a div is the documented ARIA pattern for this toggle.
    <div className={base} role="group" aria-label="Language" data-testid="lang-switcher">
      {(['fr', 'en'] as const).map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={[
            pill,
            lang === l
              ? variant === 'dark'
                ? 'bg-accent-yellow text-ink'
                : 'bg-accent-yellow text-ink'
              : 'hover:bg-paper/10',
          ].join(' ')}
          data-testid={`lang-${l}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
